import * as AcceleratedChainExpansion from './AcceleratedChainExpansion'
import * as BankAccount from './BankAccount'
import * as Common from './Common'
import * as InAppNotification from './InAppNotification'
import * as InternalAddress from './InternalAddress'
import * as Payments from './Payments'
import * as ProposalDetail from './ProposalDetail'
import * as ProposalType from './ProposalType'
import * as TransferInstruction from './TransferInstruction'
import * as TransferLocation from './TransferLocation'
import * as TravelRulePerson from './TravelRulePerson'
import * as WalletApprovalTransactionDetail from './WalletApprovalTransactionDetail'

export const TypeGuards = {
  AcceleratedChainExpansion,
  BankAccount,
  Common,
  InAppNotification,
  InternalAddress,
  TransferInstruction,
  TransferLocation,
  TravelRulePerson,
  Payments,
  ProposalDetail,
  ProposalType,
  WalletApprovalTransactionDetail,
}
